import { Col, Row, Spin } from 'antd';
import { StyledContainer } from '../../components/container/styles';
import { TextLarge } from '../../components/text';
import { CardTheme } from '../../components/card';
import React from 'react';
import { useGetScanDeliveryList } from './hooks/useGetScanDeliveryList';
import { RenderForm } from '../../components/forms';
import { ButtonTheme } from '../../components/buttons';
import { Gap } from '../../components/space';
import { ContainerButton } from '../../styles/global-style';
import { columns } from './columns';
import { ResponsivePageLayout } from '../../components/page/responsive-layout/ResponsivePageLayout';
import { UpdateTrackingModal } from './modals/UpdateTrackingModal';
import { UploadExcelModal } from './modals/UploadExcelModal';
import { FORM_DATA, FORM_SHIPPING, FORM_TRACKING_DATA } from './form';

export const ScanDelivery = () => {
  const {
    control,
    setValue,
    getValues,
    setFocus,
    shippingSelfOptions,
    handleOnEnter,
    isLoadingClaimcode,
    tableData,
    handleDeleteRecord,
    openTracking,
    onToggleTracking,
    setTableData,
    onOpenTracking,
    isLoadingOnsubmitTracking,
    onSubmit,
    handleSubmit,
    openUploadExcel,
    onToggleUploadExcel,
    selectedRow,
  } = useGetScanDeliveryList();

  return (
    <Spin spinning={isLoadingClaimcode || isLoadingOnsubmitTracking}>
      <StyledContainer>
        <TextLarge text="ยิงจ่ายพัสดุ (คำเตือน ไม่ควร รีเฟรชหน้าจอระหว่างการแสกน)" />
        <Row gutter={12}>
          <Col span={8}>
            <CardTheme>
              <TextLarge text="ข้อมูลการยิง" />
              <RenderForm
                control={control}
                getValues={getValues}
                setValue={setValue}
                setFocus={setFocus}
                forms={FORM_TRACKING_DATA({ onEnter: handleOnEnter })}
              />
            </CardTheme>
          </Col>
          <Col span={16}>
            <CardTheme>
              <TextLarge text="ข้อมูลเอกสาร" />
              <RenderForm
                control={control}
                getValues={getValues}
                setValue={setValue}
                forms={FORM_DATA()}
              />
            </CardTheme>
          </Col>
        </Row>
        <Gap />
        <Row justify="space-between" align="middle">
          <Col span={6}>
            <RenderForm
              control={control}
              getValues={getValues}
              setValue={setValue}
              forms={FORM_SHIPPING({ shippingSelfOptions })}
            />
          </Col>
          <Col>
            <ButtonTheme useFor="IMPORT" onClick={onToggleUploadExcel} />
            {openUploadExcel && (
              <UploadExcelModal open={openUploadExcel} onToggle={onToggleUploadExcel} />
            )}
          </Col>
        </Row>
        <ResponsivePageLayout
          tableLayout={{
            columns: columns({ handleDeleteRecord, onOpenTracking }),
            dataSource: tableData,
            rowKey: 'claimId',
          }}
        />
        <ContainerButton right>
          <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} style={{ marginTop: 10 }} />
        </ContainerButton>
        {openTracking && (
          <UpdateTrackingModal
            open={openTracking}
            onToggle={onToggleTracking}
            tableData={selectedRow}
            setTableData={setTableData}
          />
        )}
      </StyledContainer>
    </Spin>
  );
};
